module.exports = __webpack_public_path__ + "static/media/MacPortrait2w300@1x.86844132.webp";